import React from "react";
import { TablePagination } from "@mui/material";

const Pagination = ({
  totalCount,
  pageSize,
  pageNo,
  pageChangeHandler,
  rowsPerPageHandler,
}) => {
  return (
    <TablePagination
      rowsPerPageOptions={[10, 20, 30]}
      component="div"
      count={totalCount}
      rowsPerPage={pageSize}
      page={pageNo}
      onPageChange={pageChangeHandler}
      onRowsPerPageChange={rowsPerPageHandler}
    />
  );
};

export default Pagination;
